/*
 * Raffle simulator intro renderer  ·  assets/hoh-raffle.js
 *
 * Builds the intro panel for the "Simulate this month's raffle"
 * lightbox. Lives outside sections/hall-of-heroes.liquid so the
 * section file stays under Shopify's 256 KB limit.
 *
 * Layout, top to bottom:
 *   - Title ("Simulate {Month}'s Raffle")
 *   - Subtext (one line on how the draw works)
 *   - Ticket flourish row (5 rainbow-sweep ticket icons, decorative)
 *   - Rules reminder card (3 plain-language lines, each with a
 *     ticket icon — restates the rules the user has already seen
 *     elsewhere so they don't have to dig)
 *   - Stats row (heroes, total tickets)
 *   - "Draw the Winner" button
 *
 * Public:
 *   window.hohRenderRaffleIntro({ total, chars, monthName })
 *     Renders the intro into #hoh-raffle-inner.
 */
(function(){
  'use strict';

  function rulesLine(text){
    return '<div class="hoh-raffle-rules-line">' +
      '<span class="hoh-tk-icon hoh-tk-icon-inline" aria-hidden="true"></span>' +
      '<span>' + text + '</span>' +
    '</div>';
  }

  /* R87: Monthly raffle bonus ticket. The single ticket icon below
     the title is the ONLY ticket freebie on the entire site. Tap to
     claim +1 ticket per month, gated on:
       - signed-in email present
       - has at least one submitted character to apply it to
     The 4 decorative ticket icons that used to flank it were removed
     by user request — one icon, one purpose, one tap. */
  function _monthlyBonusKey(){
    var d = new Date();
    return 'hoh-raffle-monthly-bonus-' + d.getFullYear() + '-' + (d.getMonth()+1);
  }
  function _monthlyBonusClaimed(){
    try { return localStorage.getItem(_monthlyBonusKey()) === '1'; } catch(_){ return false; }
  }
  function _markMonthlyBonusClaimed(){
    try { localStorage.setItem(_monthlyBonusKey(), '1'); } catch(_){}
  }
  function _userHasSubmittedCharacter(){
    /* Use the same source the wallet apply flow uses — hohTicketState.my_characters
       is the authoritative list of heroes the signed-in user submitted. */
    try {
      var rows = (window.hohTicketState && window.hohTicketState.my_characters) || [];
      return rows.length > 0;
    } catch(_){ return false; }
  }
  function _userEmail(){
    try {
      if(typeof window.hohYourHallEmail === 'function') return window.hohYourHallEmail() || '';
    } catch(_){}
    return '';
  }
  window.hohClaimMonthlyRaffleBonus = function(btn, ev){
    if(ev){ try { ev.stopPropagation(); ev.preventDefault(); } catch(_){} }
    if(!btn) return;
    if(_monthlyBonusClaimed()){
      try {
        btn.classList.remove('hoh-raffle-tk-shake');
        void btn.offsetWidth;
        btn.classList.add('hoh-raffle-tk-shake');
        setTimeout(function(){ btn.classList.remove('hoh-raffle-tk-shake'); }, 450);
      } catch(_){}
      try { window.hohShowHeartToast('Already claimed', 'Your monthly bonus ticket is gone for ' + new Date().toLocaleString('default', {month:'long'}) + '.'); } catch(_){}
      return;
    }
    /* Gate: requires email + at least one submitted character. */
    var email = _userEmail();
    var hasChar = _userHasSubmittedCharacter();
    if(!email){
      try { window.hohShowHeartToast('Sign in first', 'Submit a hero (or sign in with the email you used) to unlock the monthly ticket.'); } catch(_){}
      return;
    }
    if(!hasChar){
      try { window.hohShowHeartToast('No hero yet', 'Submit a character first. The bonus ticket only counts once you have a hero to apply it to.'); } catch(_){}
      return;
    }
    /* Mark claimed + grant via wallet. The wallet helper lives in
       hoh-tickets.js as hohAddUnspentTicket(n, 'raffle_claim'). The ticket lands in
       the same wallet the wander milestones + bounty fill, so the
       user can apply it from My Submitted just like any other
       earned ticket. */
    _markMonthlyBonusClaimed();
    if(typeof window.hohAddUnspentTicket === 'function'){
      try { window.hohAddUnspentTicket(1, 'raffle_claim'); } catch(_){}
    }
    /* R95: Celebration. Earning a ticket on the house should feel
       like a moment, not a silent localStorage write. We:
         1. Pulse + flash the source button
         2. Fly a ticket sprite from the button to the wallet pill
            in the header
         3. Spawn confetti
         4. Drop a "Bonus Ticket Claimed" banner
       All of these are best-effort — if a helper isn't loaded, we
       degrade silently to the toast. */
    /* R95: Fire the celebration FIRST so the user sees the colored
       ticket animate out before it greys to the claimed state. The
       grey-out is delayed ~700ms so the fly sprites have time to
       leave the source button. */
    try { _flyMonthlyTicketToWallet(btn); } catch(_){}
    try {
      if(typeof window.spawnConfetti === 'function') window.spawnConfetti();
    } catch(_){}
    try { _spawnMonthlyTicketBanner(btn); } catch(_){}
    try { window.hohShowHeartToast('Bonus ticket claimed', 'Apply it to any hero in your hall.'); } catch(_){}
    setTimeout(function(){
      try { btn.classList.add('hoh-raffle-tk-claimed'); } catch(_){}
    }, 700);
  };

  /* R95: Fly a ticket sprite from the source button to the wallet
     pill in the page header. Mirrors the heart-fly animation pattern
     so the visual vocabulary stays consistent. */
  function _flyMonthlyTicketToWallet(srcEl){
    var pill = document.getElementById('hoh-tk-header')
            || document.getElementById('hoh-tk-header-wallet-row')
            || document.getElementById('hoh-tk-header-wallet-count');
    if(!pill || !srcEl) return;
    var br = srcEl.getBoundingClientRect();
    var pr = pill.getBoundingClientRect();
    if(!br.width || !pr.width) return;
    var startX = br.left + br.width / 2;
    var startY = br.top + br.height / 2;
    var endX = pr.left + pr.width / 2;
    var endY = pr.top + pr.height / 2;
    /* Spawn 3 sprites with a small stagger so the moment reads as
       "ticket is moving" rather than a single dot. */
    for(var i = 0; i < 3; i++){
      (function(idx){
        setTimeout(function(){
          var el = document.createElement('div');
          el.className = 'hoh-raffle-tk-fly';
          /* Inline ticket icon — same SVG mask the .hoh-tk-icon uses. */
          el.innerHTML = '<span class="hoh-tk-icon hoh-raffle-tk-fly-icon" aria-hidden="true"></span>';
          var jx = (Math.random() * 16 - 8);
          var jy = (Math.random() * 12 - 6);
          el.style.left = (startX + jx) + 'px';
          el.style.top = (startY + jy) + 'px';
          document.body.appendChild(el);
          requestAnimationFrame(function(){
            el.style.transform = 'translate(' + (endX - startX - jx) + 'px,' + (endY - startY - jy) + 'px) scale(0.55)';
            el.style.opacity = '0';
          });
          setTimeout(function(){ if(el.parentNode) el.parentNode.removeChild(el); }, 1200);
        }, idx * 110);
      })(i);
    }
    /* Pulse the wallet pill once the flock is about to land. */
    setTimeout(function(){
      try {
        var p = document.getElementById('hoh-tk-header');
        if(p){
          p.classList.remove('hoh-tk-heart-pulse');
          void p.offsetWidth;
          p.classList.add('hoh-tk-heart-pulse');
          setTimeout(function(){ p.classList.remove('hoh-tk-heart-pulse'); }, 900);
        }
      } catch(_){}
    }, 700);
  }

  /* R95: Banner above the source button — "Bonus Ticket Claimed"
     in the brand cream/gold gradient. Drifts up + fades over ~2s. */
  function _spawnMonthlyTicketBanner(srcEl){
    var anchor = srcEl;
    if(!anchor) return;
    var rect;
    try { rect = anchor.getBoundingClientRect(); } catch(_){ return; }
    if(!rect || !rect.width) return;
    var startX = rect.left + rect.width / 2;
    var startY = rect.top - 4;
    var el = document.createElement('div');
    el.className = 'hoh-raffle-tk-banner';
    el.innerHTML = '<span class="hoh-raffle-tk-banner-eyebrow">BONUS TICKET</span>' +
                   '<span class="hoh-raffle-tk-banner-amount">+1 CLAIMED</span>';
    el.style.left = startX + 'px';
    el.style.top = startY + 'px';
    document.body.appendChild(el);
    requestAnimationFrame(function(){
      el.style.transform = 'translate(-50%,-100%) scale(1)';
      el.style.opacity = '1';
    });
    setTimeout(function(){
      try {
        el.style.transition = 'transform 1.4s cubic-bezier(0.4,0,0.2,1),opacity 1.4s ease-out';
        el.style.transform = 'translate(-50%,calc(-100% - 36px)) scale(1.04)';
        el.style.opacity = '0';
      } catch(_){}
    }, 700);
    setTimeout(function(){ if(el.parentNode) el.parentNode.removeChild(el); }, 2200);
  }

  window.hohRenderRaffleIntro = function(opts){
    opts = opts || {};
    var inner = document.getElementById('hoh-raffle-inner');
    if(!inner) return;
    var rawTotal = Number(opts.total) || 0;
    var total = rawTotal.toLocaleString();
    var chars = Number(opts.chars) || 0;
    var month = opts.monthName || '';
    /* HALL-SPEED-02: opened while the Hall is still bringing in its heroes, the numbers wait ("…") and the draw can
       still be pressed: it runs once every ticket is in (hohRunRaffle), and this card is drawn again with the totals */
    var pending = !!opts.pending;
    var canDraw = pending || (chars > 0 && rawTotal > 0);
    /* R141-E: Removed the clickable bonus-ticket icon and the
       "Tap the ticket — once a month, on the house" subtitle from
       the simulate raffle modal. The modal is now purely a preview
       of the monthly draw — no claim mechanic embedded.
       The hohClaimMonthlyRaffleBonus handler stays defined above
       so any deep-linked or older clients calling it gracefully
       no-op rather than throw, but nothing in the rendered UI
       triggers it anymore. */
    inner.innerHTML =
      '<div class="hoh-raffle-intro">' +
        '<h2 class="hoh-raffle-title">Simulate ' + month + '’s Raffle</h2>' +
        '<p class="hoh-raffle-sub">Weighted by raffle tickets across every hero in the Hall. On the 1st of each month, I run this same draw to pick the real winner.</p>' +
        '<div class="hoh-raffle-rules-card">' +
          /* R793 (Jan, 2026-09-22): a ticket is given, one a day, to each of
             your own heroes on its page. Nothing is earned from quests. */
          (((typeof window.hohR793Live === 'function') && window.hohR793Live())
            ? rulesLine('Every ticket on a hero is a separate entry in the draw. More tickets, better odds.') +
              rulesLine('Each of your heroes takes one ticket a day. Open your hero in the Hall and tap Give today’s ticket.')
            : rulesLine('Every ticket you earn is a separate entry in the draw. More tickets, better odds.') +
              rulesLine('Tickets come from submitting heroes and keeping the Hall’s quality high through the daily quests.')) +
          rulesLine('Most months I draw one winner. Some months at random I draw two or three.') +
        '</div>' +
        '<div class="hoh-raffle-stats">' +
          '<div class="hoh-raffle-stat"><div class="hoh-raffle-stat-num">' + (pending ? '…' : chars) + '</div><div class="hoh-raffle-stat-label">Heroes</div></div>' +
          '<div class="hoh-raffle-stat"><div class="hoh-raffle-stat-num">' + (pending ? '…' : total) + '</div><div class="hoh-raffle-stat-label">Total Tickets</div></div>' +
        '</div>' +
        '<button type="button" class="hoh-raffle-draw-btn" onclick="hohRunRaffle(this)"' + (canDraw ? '' : ' disabled aria-disabled="true"') + '>' + (canDraw ? '⚔ Draw the Winner' : 'Draw Unavailable') + '</button>' +
        '<p class="hoh-raffle-sim-note"' + (canDraw && !pending ? '' : ' role="status"') + '>' + (pending ? 'Counting every ticket in the Hall…' : canDraw ? 'Preview only. The real draw happens on the 1st.' : 'No eligible heroes could be loaded. Close this window and try again.') + '</p>' +
      '</div>';
    if(typeof window.hohResetViewportModal === 'function'){
      window.hohResetViewportModal('hoh-raffle-modal');
    }
  };
})();
